import Typography from "@mui/material/Typography";
import { styled } from '@mui/material/styles';
import React from "react";
import { Link } from "react-router-dom";
import { ToastOptions, toast } from "react-toastify";

interface ITriggerToast {
  message?: string;
  solicitudId?: number;
  type?: "info" | "success" | "warning" | "error";
  props?: ToastOptions;
}

export const sendToast = ({
  message,
  type = "success",
  props,
  solicitudId,
}: ITriggerToast) => {
  toast[type](
    <ToastContent>
      <Message>{message}</Message>
      {!!solicitudId && (
        <StyledLink to={`#/${solicitudId}`}>Ver solicitud</StyledLink>
      )}
    </ToastContent>,
    { position: "top-right", ...props },
  );
};

const ToastContent = ({ children }: { children: React.ReactNode }) => (
  <Container>{children}</Container>
);

const Container = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
});
const Message = styled(Typography)(({ theme }) => ({
  lineHeight: "20px",
  fontSize: "14px",
  fontWeight: 600,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.grey[800],
}));
const StyledLink = styled(Link)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: "14px",
  fontWeight: 800,
  color: "#4EAC97",
  "&:focus, &:visited, &:link, &:active": {
    textDecoration: "none",
  },
  "&:hover": {
    textDecoration: "underline",
  },
}));
